import React,{ useState, useEffect} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import { fetchBlockedNumbers,deleteBlockedNumber,addBlockedNumber } from '../../../redux/action'
import { encodePhoneNumber } from '../../../helpers/Utils'
import deleteIcon from '../../../assets/images/delete-icon.svg'
import sliderCloseIcon from '../../../assets/images/slider-close-icon.svg'
import {Row, Input, Label, Button, FormGroup } from "reactstrap";
import {Colxx} from '../../../components/shared/CustomBootstrap'


export default function BlockedNumbers() {
  const dispatch=useDispatch()
  const settings=useSelector((state)=>state.settings)
  const [currentState,setCurrentState]=useState({
    phone_no:'',
    all_texts:0,
    missed_call:0
  })
  
  const getBlockedNumbers=()=>{
    dispatch(fetchBlockedNumbers())
  }

  const handleSubmit=()=>{
    dispatch(addBlockedNumber(currentState))
    setCurrentState({phone_no:'',all_texts:0,missed_call:0})
  }

  const updateTextInput=(target)=>{
    let current=currentState;
    if( target.type == "checkbox" ){
        current[ target.name ] = (current[ target.name ] == 0 ? 1:0)
    }else{
        current[ target.name ] = target.value
    } 
    setCurrentState({...current})
   }

  useEffect(()=>{
    getBlockedNumbers()
  })
  
  
  return (
    <>
    <div className="row mt-4">
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 main-section-scroll-height">


    <div className="row pt-1">
                    <div className="col-md-6 col-lg-6 col-sm-12 co-xs-12">
                    </div>
                    <div className="col-md-6 col-lg-6 col-sm-12 co-xs-12">
                        <div className="d-flex justify-content-end align-items-center">
                            <button className="secondary-btn" type="button" data-bs-toggle="offcanvas"
                                data-bs-target="#createContactCanvas" aria-controls="createContactCanvas">
                                Add New
                            </button>
                        </div>
                    </div>
                </div>    



    <table class="mt-2 table table-borderless">
    <thead>
        <tr>
         {/*   <th className="align-middle" style={{width:'12%'}} scope="col">ID</th> */}
            
            <th className="align-middle" style={{width:'16%'}} scope="col">Number</th>
            <th className="align-middle" style={{width:'70%'}} scope="col">Number Type</th>
          {/*  <th className="align-middle" style={{width:'16%'}} scope="col">Address</th>*/}
            <th className="align-middle" style={{width:'12%'}} scope="col">Actions</th>

        </tr>
    </thead>
    <tbody>
      
     {settings && settings.blocked_numbers && settings.blocked_numbers.length>0 && settings.blocked_numbers.map((contact)=>(
         <tr key={contact.id}>
         {/*<td className="align-middle">
             <img width="32" height="32" className="img-fluid me-1" src={userIcon}/> {contact.id}</td>*/}
      
         <td className="align-middle">{encodePhoneNumber(contact.phone_no)}</td>
         <td className="align-middle">
            {contact.missed_call ? <div className="account_owner me-1">Missed Calls</div>:''}
            {contact.all_texts ? <div className="tag me-1">All Text</div>:''}

         </td>
         <td className="align-middle">
         <img onClick={()=>dispatch(deleteBlockedNumber(contact.id))} width="30" src={deleteIcon} className="ms-2 img-fluid"/>

         </td>

         </tr>
        
        ))
        }
        </tbody>
    </table>

    </div>
    </div>




    <div className="offcanvas offcanvas-end" tabIndex="-1" id="createContactCanvas" aria-labelledby="createContactCanvasLabel">
        <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="createContactCanvasLabel">Add Number</h5>
            <button type="button" className="slider-close-btn" data-bs-dismiss="offcanvas">
                <img src={sliderCloseIcon} className="img-fluid"/>
            </button>
        </div>
        <div className="offcanvas-body">
            <div  className="tags mb-3">
                <input style={{marginBottom:"30px"}} type="text"  name="phone_no" value={currentState.phone_no} onChange={(e)=>updateTextInput(e.target)} className="form-control slider-inputs" placeholder="Enter Phone Number"/>
            </div>
            <FormGroup row>
            <Colxx style={{marginLeft:"10px",maxWidth:"20%"}} >
                    <FormGroup >
                        <Input 
                            type="checkbox"
                            name = "missed_call"
                            checked={currentState.missed_call}
                            onChange = {e => { updateTextInput(e.target) }}
                        />
                    </FormGroup>
                </Colxx>
                <Colxx>
                    <Label  className="pt-0">Blocked from Missed Call Text
                    </Label>
                </Colxx>
                
            </FormGroup>


            <FormGroup row>
            <Colxx style={{marginLeft:"10px",maxWidth:"20%"}} >
                    <FormGroup >
                        <Input 
                            type="checkbox"
                            name = "all_texts"
                            checked={currentState.all_texts}
                            onChange = {e => { updateTextInput(e.target) }}
                        />
                    </FormGroup>
                </Colxx>
                <Colxx>
                    <Label  className="pt-0">Blocked from All Texts
                    </Label>
                </Colxx>
                
            </FormGroup>
            
            
          
            <div className="d-flex justify-content-end mt-4">
                <button className="slider-cancel-btn me-2" data-bs-dismiss="offcanvas" >Cancel</button>
                <button className="slider-success-btn" data-bs-dismiss="offcanvas" onClick={handleSubmit} >Add</button>
            </div>
        </div>
    </div>
    </>
  )
}
